import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CurrentQuizState {
  imgUrl?: string;
  trainerName: string;
  assessmentName?: string;
  assessmentId?: string;
  from: string;
  to: string;
  status: string;
  startDate: string;
  endDate: string;
  quizId?: string;
  quizName?: string;
  tournamentId?: string;
  allowOnMobile?: boolean;
  malPracticeCount: number;
  studentMalPracticeCount: number;
  showFailedTestCase?: boolean;
  quizType: string;
}
interface InitialState {
  currentQuiz: CurrentQuizState | null;
  type: string;
  componentType: string;
}

const initialState: InitialState = {
  currentQuiz: null,
  type: "tournament",
  componentType: "tournament",
};
const currentQuizSlice = createSlice({
  name: "currentQuiz",
  initialState,
  reducers: {
    setCurrentQuiz: (state, action: PayloadAction<CurrentQuizState>) => {
      state.currentQuiz = action.payload;
    },
    setQuizType: (state, action: PayloadAction<string>) => {
      state.type = action.payload;
    },
    setComponentType: (state, action: PayloadAction<string>) => {
      state.componentType = action.payload;
    },
    clearCurrentQuiz: (state) => {
      state.currentQuiz = null;
      state.type = "assessment";
    },
  },
});
export const {
  setCurrentQuiz,
  clearCurrentQuiz,
  setQuizType,
  setComponentType,
} = currentQuizSlice.actions;
export default currentQuizSlice.reducer;
